/** TileMapLayer property formatter for the details panel. */
import { formatNode2DProperties } from '../../../base/node2d/propertyFormatter';
export function formatTileMapLayerProperties(properties) {
    const items = [
        { label: 'Tile Set', value: properties.tile_set ?? '(none)' },
        { label: 'Cells', value: (properties.cells?.length ?? 0).toString() },
    ];
    if (!properties.enabled)
        items.push({ label: 'Enabled', value: 'No' });
    return [{ title: 'Tile Map', items }, ...formatNode2DProperties(properties)];
}
//# sourceMappingURL=propertyFormatter.js.map